import { GenericError } from './GenericError';
/**
 * Helper class to signal an api request error with response code 404.
 */
export class NotFoundError extends GenericError {
    static className = 'NotFoundError';
    constructor(props) {
        super(props);
    }
    getStatusCode() {
        return 404;
    }
}
